import {gsap} from "gsap"


class LoadingAnimation
{
  constructor(point)
  {
    this.loading_status = 0;
    this.current_point = 1;
    this.specific_point = point+1;
    this.loader = null;
    this.timeFlag = false;
    this.loaded = false;

    window.addEventListener('scroll',this.noScroll,{passive:false});
    window.addEventListener('mousewheel',this.noScroll,{passive:false});
    window.addEventListener('touchmove',this.noScroll,{passive:false});
}
  noScroll (e)
  {
    window.scrollTo(0,0);
    e.preventDefault();
  }
  start(display)
  {
    document.body.classList.add('loading');
    document.body.prepend(display);
    this.loadingMove();
    this.upTri = S('.jsSand2')
    this.dowmTri = S('.jsSand1')
    this.dropLen = S('.jsLn2')
    this.svgIcon = S('.jsLoadIcon')
    this.countTimer(display);
  }
  pointLoaded ()
  {
    this.current_point++;
    this.loadingMove();
  }
  loadingMove ()
  {
    setTimeout(()=>{
      if(this.loading_status >= 100 )
      {
        this.loaded = true;
        this.counter.innerHTML = '100 %';
        return;
      }else if(this.current_point/this.specific_point * 100 > this.loading_status)
      {
        this.counter.innerHTML = this.loading_status + ' %';
        this.loading_status += 1;
        this.loader.style.setProperty('--loading',this.loading_status+'%');
        this.loadingMove();
      }else
      {
        return
      }
    },20);
  }
  /**
   * 要素を生成する。
   * @version 1.0.1
   *
   * @param  {String} dom DOMの種類
   * @param  {String} cl [cl=""]  クラス属性
   * @param  {String} inner [inner=""]  innerHTML
   * @param  {Array}  obj [obj=[]] [{key:属性,val:value},{...}]の形式で渡す
   * @param  {HTMLObject} append appendChildする場合は親の要素を指定
   * @return {Object} HTML Elementを返す
   */
  createDom (dom, cl="",inner="", obj=[],append="")
  {
    const returnEl = document.createElement(dom);
    if(cl!=="")
    {
      if (typeof(cl) == "string" || cl instanceof String) {
        returnEl.classList.add(cl);
      } else if (cl instanceof Array) {
        cl.forEach( c => {
          returnEl.classList.add(c);
        });
      }
    }
    if(obj.length)
    {
      obj.forEach((attr, i) => {
        returnEl.setAttribute(attr.key,attr.val);
      });
    }
    if(inner!=="")
    {
      returnEl.innerHTML = inner;
    }
    if(append !== "")
    {
      append.appendChild(returnEl);
    }
    return returnEl;
  }
  sleep(ms)
  {
    return new Promise(function(resolve) {
      setTimeout(function() {
        resolve();
      }, ms);
    });
  }
  createDisplay ()
  {
    const loadingWrapper = this.createDom('div','zaty-loading');
    const svgIcon = `<svg class="svg-icon jsLoadIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000">
        <line class="svg-icon__leln-1 jsLn2" x1="1000" y1="1100" x2="1000" y2="1500" stroke="#ccc" stroke-miterlimit="10" stroke-width="80"/>
        <polygon class="svg-icon__polygon-1 jsSand1" points="1000 1100 800 1300 1200 1300 1000 1100"/>
        <line class="svg-icon__leln-2" x1="1000" y1="900" x2="1000" y2="500" fill="none" stroke-miterlimit="10" stroke-width="80"/>
        <polygon class="svg-icon__polygon-2 jsSand2" points="1000 900 800 700 1200 700 1000 900"/>
        <g class="svg-icon__path-1">
          <polygon class="path-poly" points="1425.86 1564.14 1425.86 1505.86 1000 1080 574.14 1505.86 574.14 1564.14 385.86 1564.14 385.86 1494.14 880 1000 385.86 505.86 385.86 435.86 574.14 435.86 574.14 494.14 1000 920 1425.86 494.14 1425.86 435.86 1614.14 435.86 1614.14 505.86 1120 1000 1614.14 1494.14 1614.14 1564.14 1425.86 1564.14"/>
          <path class="svg-icon__path-bg" d="M1600,450v50l-500,500,500,500v50H1440v-50l-440-440L560,1500v50H400v-50l500-500L400,500V450H560v50l440,440,440-440V450h160m28.28-28.28H1411.72v66.56L1000,900,588.28,488.28V421.72H371.72v90L380,520l480,480L380,1480l-8.28,8.29v90H588.28v-66.56L1000,1100l411.72,411.72v66.56h216.56v-90L1620,1480l-480-480,480-480,8.28-8.29v-90Z"/>
        </g>
        <rect class="svg-icon__wiln-2" x="400" y="400" width="1200" height="100"/>
        <rect class="svg-icon__wiln-1" x="400" y="1500" width="1200" height="100"/>
        <circle class="svg-icon__border" cx="1000" cy="1000" stroke-width="50" r="1200" fill="transparent" />
      </svg>`;
    const svgLogo = `<svg class="svg-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612 139.5">
        <g class="svg-logo__z">
          <polyline class="svg-logo__z-ln-1" points="4.5 44 4.5 13 126.5 13 126.5 74 88.5 74" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="9"/>
          <circle class="svg-logo__z-cl-1" cx="65.5" cy="74" r="10.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"/>
          <polyline class="svg-logo__z-ln-2" points="42.5 74 4.5 74 4.5 135 126.5 135 126.5 104" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="9"/>
        </g>
        <g class="svg-logo__a">
          <circle class="svg-logo__a-cl-1" cx="171.5" cy="13" r="10.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"/>
          <polyline class="svg-logo__a-ln-1" points="194.5 13 293.5 13 293.5 135" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="9"/>
          <line class="svg-logo__a-ln-2" x1="171.5" y1="36" x2="171.5" y2="135" stroke-width="9" stroke="#000" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          <circle class="svg-logo__a-cl-2" cx="233" cy="74" r="10.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"/>
        </g>
        <g class="svg-logo__t">
          <circle class="svg-logo__t-cl-1" cx="390.5" cy="13" r="10.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"/>
          <polyline class="svg-logo__t-ln-1" points="329.5 21 329.5 13 367.5 13" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="9"/>
          <polyline class="svg-logo__t-ln-2" points="413.5 13 451.5 13 451.5 5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="9"/>
          <line class="svg-logo__t-ln-3" x1="390.5" y1="36" x2="390.5" y2="135" stroke-width="9" stroke="#000" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </g>
        <g class="svg-logo__y">
          <circle class="svg-logo__y-cl-1" cx="485.5" cy="74" r="10.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"/>
          <line class="svg-logo__y-ln-1" x1="485.5" y1="13" x2="485.5" y2="51" fill="none" stroke="#000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="9"/>
          <line class="svg-logo__y-ln-2" x1="485" y1="97" x2="485" y2="135" fill="none" stroke="#000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="9"/>
          <polyline class="svg-logo__y-ln-3" points="508.5 74 607.5 74 607.5 13" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="9"/>
        </g>
      </svg>`;
    this.zaty_icon = this.createDom('div','zaty-loading__icon',svgIcon,[],loadingWrapper);
    this.zaty_logo = this.createDom('div','zaty-loading__logo',svgLogo,[],loadingWrapper);
    this.loader = this.createDom('div','zaty-loading__loader','<span class="zaty-loading__bar"></span>',[{key:'style',val:'--loading: 0%;'}],loadingWrapper);
    this.counter = this.createDom('span','zaty-loading__counter','',[],loadingWrapper);
    return loadingWrapper;
  }
  animate({timing, draw, duration})
  {
    let start = performance.now()

    return requestAnimationFrame(function animate(time) {

      let timeFraction = (time - start) / duration;
      if (timeFraction > 1) timeFraction = 1;


      let progress = timing(timeFraction)

      draw(progress);

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      }

    });
  }
  easeOut (tf)
  {
    return 1 - Math.pow(1 - tf, 3);
  }
  easeIn (tf)
  {
    return tf * tf * tf;
  }
  loopAnimation (display)
  {
    this.iconLoaded = false;
    const tl = gsap.timeline({
      onStart: () => {
        gsap.fromTo( '.jsLn2',
          {
            strokeDashoffset: 1840,
          },
          {
            strokeDashoffset: 620,
            duration: 1.4,
            delay: .4,
            ease: "power1.easeIn",
          }
        )
        gsap.fromTo( '.jsSand2',
              {
                scale: 1.5,
                x: 400,
                y: 350,
                transformOrigin: "center bottom"
              },
              {
                scale: 0,
                duration: .8,
                delay: .14,
                ease: "power1.easeIn",
              }
        )
      }
    })
    tl.fromTo( '.jsSand1',
        {
          scale: 0,
          x: -800,
          y: -850,
          transformOrigin: "center bottom"
        },
        {
          scale: 1.5,
          duration: 1,
          delay: .8,
          ease: "power1.easeIn",
        }
      )
      .fromTo( '.jsLoadIcon',
        {
          rotation: 0,
          transformOrigin: "center center",
        },
        {
          rotation: 180,
          duration: .36,
          onStart: ()=>{
            gsap.fromTo('.jsSand1',
                  {
                    y: -850
                  },
                  {
                    y: -1000,
                    duration: .36
                  }
                )
          }
        }
      )
      .to( '.jsLoadIcon',
        {
          onStart: () => {
            setTimeout(()=>{
              this.countTimer(display)
            },50)
          }
        }
      )
  }
  async resetStyle ()
  {
    this.upTri.style.transform = 'translate3d(0,0,0) scale(1.5)'
    this.dropLen.style.strokeDashoffset = '1840'
    this.dowmTri.style.transform = 'translate3d(0,2.1em,0) scale(0)'
    this.svgIcon.style.transform = 'translate3d(-50%,-50%,0) rotate(0deg)'
    return true
  }
  async countTimer (display)
  {
    this.statusArr = [0,0,0]
    await this.resetStyle()
    if( !this.loaded )
    {
      this.loopAnimation(display)
    }else
    {
      this.countEndCheck(display)
    }
  }
  async countEndCheck (display) {
    if( this.loaded )
    {
      clearTimeout(this.counterTimeout)
      await this.resetStyle()
      gsap.fromTo( '.jsSand2',
        {
          scale: 1.5,
          x: 400,
          y: 350,
          transformOrigin: "center bottom"
        },
        {
          scale: 1,
          duration: 1,
          ease: "power1.easeIn"
        }
      )
      gsap.fromTo( '.jsLn2',
        {
          strokeDashoffset: 1840,
        },
        {
          strokeDashoffset: 1230,
          duration: 1,
        }
      )
      this.sleep(1000)
       .then(()=>{
         this.fullLoaded(display);
       })
    }
  }
  fullLoaded (display)
  {
    this.zaty_icon.classList.add('zaty-loading__icon--loaded');
    this.loader.classList.add('zaty-loading__loader--loaded');
    this.zaty_logo.classList.add('zaty-loading__logo--loaded');
    this.counter.classList.add('zaty-loading__counter--loaded');
    this.sleep(2800)
      .then(()=>{
        document.body.classList.remove('loading');
        document.body.classList.add('loaded');
        const tl = gsap.timeline()
        gsap.to( '.zaty-loading',
            {
              scale: 2,
              transform: "translate(-50%,-50%)",
              duration: 1.6,
              transformOrigin: "center center"
            }
          )
        tl.to( '.zaty-loading',
            {
              marginTop: "-100vh",
              duration: 1,
              ease: "power1.easeIn"
            }
          )
          .to( '.zaty-loading',
            {
              onStart: () => {
                document.body.classList.remove('loaded');
                window.removeEventListener('scroll',this.noScroll,{passive:false});
                window.removeEventListener('mousewheel',this.noScroll,{passive:false});
                window.removeEventListener('touchmove',this.noScroll,{passive:false});
                document.body.removeChild(display);
              }
            }
          )
      })
  }
}
export { LoadingAnimation as default }
